import { jsxs, jsx } from "react/jsx-runtime";
const IconSocialYouTubeSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M22.54 6.705a2.755 2.755 0 0 0-1.945-1.945C18.88 4.3 12 4.3 12 4.3s-6.88 0-8.595.46A2.755 2.755 0 0 0 1.46 6.705C1 8.42 1 12 1 12s0 3.58.46 5.295a2.755 2.755 0 0 0 1.945 1.945C5.12 19.7 12 19.7 12 19.7s6.88 0 8.595-.46a2.755 2.755 0 0 0 1.945-1.945C23 15.58 23 12 23 12s0-3.58-.46-5.295ZM9.8 15.3V8.7l5.716 3.3L9.8 15.3Z" })
    ]
  }
);
export {
  IconSocialYouTubeSvg
};
